import React, { Component } from "react";

/**
 * @class
 * @classdesc Rating control which allows the user to give a feedback about the user experience
 * using a 5-star rating and a comment field.
 *
 * @param {object} paramObj - Parameters for initialization.
 * @param {object} paramObj.hcs - HcS instance
 */
export default class RatingControl
{
    get overlayContainer() {
        return this.hcs.api.instance(".hcs-background-main");
    }

    /**
     * Return current rating data.
     */
    get data() {
        return {
            comment: this.instance(".hcs-rating-comment-field").value.trim(),
            rating: (document.querySelectorAll(".hcs-rating .hcs-rating-level a.hcs-active") || []).length
        };
    }

    constructor(paramObj) {
        let self = this;

        this.hcs = paramObj.hcs;
        this.container = this.hcs.api.instance(".hcs-rating");

        this.instance(".hcs-close").addEventListener("click", _ => {
            self.close();
        });

        this.instance("button.hcs-cancel").addEventListener("click", _ => {
            self.close();
        });

        this.instance("button.hcs-submit").addEventListener("click", _ => {
            self.rate();
        });

        this.instance(".hcs-rating-level a").forEach(ri => {
            ri.addEventListener("click", event => {
                event.currentTarget.classList.toggle("hcs-active", true);

                let next = event.currentTarget;
                let prev = event.currentTarget;

                while(next = next.nextElementSibling) {
                    next.classList.toggle("hcs-active", false);
                }

                while(prev = prev.previousElementSibling) {
                    prev.classList.toggle("hcs-active", true);
                }

                if(self.data.rating > 0) {
                    self.instance(".hcs-rating-level .hcs-note").classList.remove("hcs-active");
                }
            });
        });
    }

    rate() {
        let self = this;

        if(this.data.rating < 1) {
            this.instance(".hcs-rating-level .hcs-note").classList.add("hcs-active");
            return;
        }

        this.instance(".hcs-rating-level .hcs-note").classList.remove("hcs-active");

        this.hcs.api.callback({
            url: this.hcs.api.getUrl(`log/rate/${this.hcs.configurationId}`),
            data: this.data,
            method: "POST"
        }).then(_ => {
            self.close();
        });
    }

    /**
     * Reset all fields to initial state.
     */
    reset() {
        this.instance(".hcs-rating-comment-field").value = "";
        this.instance(".hcs-rating-level a").forEach(ri => {
            ri.classList.remove("hcs-active");
        });
    }

    /**
     * Show rating control.
     * This also ensures that duplicate rating are avoided.
     * Therefore we check the current session state for already completed ratings.
     * @param {object} [options] - Additional call options
     * @param {object} [options.force=false] - When "true" open rating control without check of previous user ratings (per session).
     * @returns {bool} "true" when reating controls opens. "false" when rating for this configuration has
     * already been done and rating dialog stays hidden.
     */
    show(options) {
        var opts = Object.assign({}, {
            force: false
        }, options);

        if(!opts.force && this.sessionState("all")) {
            return false;
        }

        this.reset();

        this.overlayContainer.classList.add("hcs-show");
        this.container.classList.add("hcs-show");

        return true;
    }

    close() {
        this.sessionState(true);

        this.container.classList.remove("hcs-show");
        this.overlayContainer.classList.remove("hcs-show");
    }

    instance(selector) {
        return this.hcs.api.instance(selector, this.container);
    }

    /**
     * Set rating state for current configuration.
     * To avoid users being penetrated by the rating control for the same configuration several
     * times we store the current rating state in user's session storage.
     * @param {any} [stateOrRequestType] - Set state for current configuration. Use "true" to mark this configuration as "already rated".
     * When this parameter is not specified the function returns the state of the current configuration, "current" does the same.
     * Using "all" checks that state for all configurations. Returns "true" when there is at least one entry with "true" state.
     * @returns {bool} Current configuartion rating state, "true" when already rated.
     */
    sessionState(stateOrRequestType) {
        let ratingStateSession = JSON.parse(this.hcs.api.storage.session("rating-states") || "{ }");

        if(typeof stateOrRequestType === "boolean") {
            ratingStateSession[this.hcs.configurationId] = stateOrRequestType;
            this.hcs.api.storage.session("rating-states", JSON.stringify(ratingStateSession));
            return;
        }

        switch(stateOrRequestType) {
            case "all":
                var allState = false;

                Object.keys(ratingStateSession).forEach(function(key) {
                    allState ||= ratingStateSession[key];
                });

                return allState;
                break;

            case "current":
            default:
                return ratingStateSession[this.hcs.configurationId] || false;
        }
    }
}


export class HcsRatingButton extends Component
{
    constructor(props) {
        super(props);

        this.startRating = this.startRating.bind(this);
    }

    startRating(event) {
        const { hcs } = this.props;

        hcs.api.startRating({ force: true });
    }

    render() {
        const { hcs } = this.props;

        return <React.Fragment>
            <div></div>
            <a onClick={event => { this.startRating(event); }}>{hcs.t.gui("RatingControl_ButtonText")}</a>
        </React.Fragment>;
    }
}